export const escapeRegexSyntax = (value: string) => value?.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
